// @flow
import getSearchQueryOptions from 'utils/search/getSearchQueryOptions';
import { differenceInDays, isBefore } from 'date-fns';
import { configString } from 'utils/config';
import algoliaSearch from 'utils/algoliaSearch';
import { getItem, setItem } from 'utils/localStorage';
import { getDate } from 'utils/date';

const FEATURED_JOBS_KEY = 'featuredJobs';

export const fetchFeaturedJobs = ({
  query,
  searchLocation,
  radius
}: {
  query: string,
  searchLocation: ?SearchLocation,
  radius: string
}) => {
  const queryOptions = getSearchQueryOptions(
    {},
    {
      location: searchLocation,
      radius,
      pageIndex: 0,
      sort: 'relevance',
      isFeaturedJobs: true
    }
  );

  const searchConfig = {
    appId: configString('algolia', 'appId'),
    apiKey: configString('algolia', 'searchApiKey')
  };

  return algoliaSearch(searchConfig, query, queryOptions);
};

export const selectFeaturedJob = (jobIds: Array<string>) => {
  const previousJobs: { [string]: { id: string, timestamp: Date } } =
    getItem(FEATURED_JOBS_KEY) || {};
  const previousJobsArray = Object.keys(previousJobs)
    .map(key => previousJobs[key])
    .filter(job => differenceInDays(new Date(), getDate(job.timestamp)) < 30);
  let featuredJob;
  const unfeaturedJobIds = jobIds.filter(
    id => !previousJobsArray.some(job => job.id === id)
  );
  if (unfeaturedJobIds.length) {
    const featuredJobId = unfeaturedJobIds[0];
    featuredJob = { id: featuredJobId };
  } else {
    featuredJob = previousJobsArray
      .filter(({ id }) => jobIds.indexOf(id) > -1)
      .sort((a, b) =>
        isBefore(getDate(a.timestamp), getDate(b.timestamp)) ? -1 : 1
      )[0];
  }
  const jobsToStore = previousJobsArray.reduce(
    (acc, job) => ({ ...acc, [job.id]: job }),
    {}
  );
  jobsToStore[featuredJob.id] = { id: featuredJob.id, timestamp: new Date() };
  setItem(FEATURED_JOBS_KEY, jobsToStore);
  return featuredJob ? featuredJob.id : null;
};
